import CheckBox from '@lib/components/CheckBox';
import ErrorMessage from '@lib/components/ErrorMessage';
import InputText from '@lib/components/InputText';
import *  as IInputText from '@lib/components/InputText';
import Select from '@lib/components/Select';
import Selector from '@lib/components/Selector';
import TitleBar from '@lib/components/TitleBar';
import *  as ITitleBar from '@lib/components/TitleBar';
import { IInputProps } from '@lib/containers/Input';
import { IInputChannel } from '@lib/types';
import { diffBetweenObject } from '@lib/util/util';

import * as React from 'react';

import './Input.css';



interface IInputState {
  idDevice: string;
  input: IInputChannel;
  isCounterMaxError: boolean;
  isCounterWeightError: boolean;
  isIntegrationValueError: boolean;
  isIntegrationUnitError: boolean;
  isLabelError: boolean;
  isModeError: boolean;
  selectorShow: boolean;
  selectorProperty: string;
  selectorValue: number;
  selectorStep: number;
  selectorMin: number;
  selectorMax: number;
  selectorLabel: string;
  selectorUnit: string;
  modified: boolean;
}


class Input extends React.Component<IInputProps, IInputState> {

  public constructor(props: IInputProps) {
    super(props);
    this.state = {
      idDevice: this.props.idDevice,
      input: JSON.parse(JSON.stringify(this.props.input || {})),
      isCounterMaxError: false, isCounterWeightError: false, isIntegrationUnitError: false, isIntegrationValueError: false,
      isLabelError: false, isModeError: false,
      modified: false,
      selectorLabel: '', selectorMax: 0, selectorMin: 0, selectorProperty: '', selectorShow: false, selectorStep: 0, selectorUnit: '', selectorValue: 0,
    };
  }

  /**
   * Fired when user change a field field
   * @param state 
   * @param field
   * @param event 
   */
  public onChangeField(state: IInputState, field: string, event: React.ChangeEvent<HTMLSelectElement>) {
    const tmpInput = this.state.input;
    tmpInput[field] = event.currentTarget.value,
      this.setState(({ input }) => ({
        input: tmpInput, modified: true,
      }));
  }


  /**
   * Fired when user clicks on "Close" in selector
   * @param state 
   * @param event 
   */
  public onSelectorCloseClick(state: IInputState, event: React.MouseEvent<HTMLDivElement>) {
    this.onChangeFromSelector(state, false);
  }

  /**
   * Repercute changes on the fly
   * @param state 
   * @param selectorShow 
   */
  public onChangeFromSelector(state: IInputState, selectorShow: boolean) {
    if (this.state.selectorProperty === '' || this.state.selectorProperty === undefined) {
      this.setState({ selectorShow: false });
      return;
    }
    const tmp = this.state.input;
    tmp[this.state.selectorProperty] = Math.round(this.state.selectorValue * 10) / 10;
    this.setState({ selectorShow, input: { ...state.input, tmp }, modified: true, });
  }

  /**
   * Fired when user clicks on "Up" in selector
   * @param state 
   * @param event 
   */
  public onInputClick(property: string, min: number, max: number, step: number, event: React.MouseEvent<HTMLInputElement>) {
    this.setState({
      selectorLabel: this.props.i18n.Input[property + 'Short'],
      selectorMax: max,
      selectorMin: min,
      selectorProperty: property,
      selectorShow: true,
      selectorStep: step,
      selectorValue: this.state.input[property],
    });
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!this.state.modified || confirm(this.props.i18n.Common.confirmCancel)) {
      this.props.onGoBack();
    }
  }


  /**
   * Fired when user clicks on "Mail" checkbox
   * @param state 
   * @param event 
   */
  public onMailClick(state: IInputState, event: React.MouseEvent<HTMLDivElement>) {
    const tmpInput = this.state.input;
    tmpInput.mailAlert = tmpInput.mailAlert === 1 ? 0 : 1,
      this.setState(({ input }) => ({
        input: tmpInput, modified: true,
      }));
  }

  /**
   * Fired when user clicks on "Sms" checkbox
   * @param state 
   * @param event 
   */
  public onSmsClick(state: IInputState, event: React.MouseEvent<HTMLDivElement>) {
    const tmpInput = this.state.input;
    tmpInput.smsAlert = tmpInput.smsAlert === 1 ? 0 : 1,
      this.setState(({ input }) => ({
        input: tmpInput, modified: true,
      }));
  }

  /**
   * Fired when user clicks on "Push" checkbox
   * @param state 
   * @param event 
   */
  public onPushClick(state: IInputState, event: React.MouseEvent<HTMLDivElement>) {
    const tmpInput = this.state.input;
    tmpInput.pushAlert = tmpInput.pushAlert === 1 ? 0 : 1,
      this.setState(({ input }) => ({
        input: tmpInput, modified: true,
      }));
  }

  /**
   * Fired when user click on save button
   * @param event 
   */
  public onSaveClick(event: React.MouseEvent<HTMLDivElement>) {
    // Only take different fields
    const channelWithChange = diffBetweenObject(this.props.input, this.state.input);
    this.props.onSaveInput(this.state.idDevice, this.props.site!.name, channelWithChange);
  }


  /**
   * Fired when slider is moved
   * @param state 
   * @param value 
   */
  public onSelectorChange(state: IInputState, value: number) {
    this.setState({ selectorValue: value, modified: true, }, () => {
      this.onChangeFromSelector(this.state, true);
    });
  }

  /**
   * Render React method
   */
  public render() {

    const i18n = this.props.i18n;

    if (this.props.input === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    };

    return (
      <div className="standardPage inputs">
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={this.state.input.label}
          rightIcon={this.props.saving ? ITitleBar.ICO_CHECK_ROTATING : ITitleBar.ICO_CHECK}
          onRightButtonClick={this.onSaveClick.bind(this, this.state)}
        />

        <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />

        <Selector label={this.state.selectorLabel}
          maxValue={this.state.selectorMax}
          minValue={this.state.selectorMin}
          step={this.state.selectorStep}
          onCloseClick={this.onSelectorCloseClick.bind(this, this.state)}
          onChange={this.onSelectorChange.bind(this, this.state)}
          show={this.state.selectorShow} value={this.state.selectorValue}
          unit={this.state.selectorUnit} />
        <div className="contentCentered">
          <div className="grid">
            {/* Label */}
            <div>
              <InputText icon={IInputText.ICO_FONT} type="text" required={true} name={i18n.Input.label} id="label" isError={this.state.isLabelError} error={i18n.Common.errors.email} value={this.state.input.label} onChange={this.onChangeField.bind(this, this.state, 'label')} />
            </div>
            {/* Mode */}
            <div>
              <Select
                icon={IInputText.ICO_COG} required={true} name={i18n.Common.mode} id="mode"
                isError={this.state.isModeError} error={i18n.Common.errors.invalidField} value={'' + this.state.input.mode}
                onChange={this.onChangeField.bind(this, this.state, 'mode')}
                optionsValue={['0', '1', '2']}
                optionsLabel={[i18n.Input.mode_0, i18n.Input.mode_1, i18n.Input.mode_2]}
              />
            </div>
            {/* Way */}
            <div>
              <Select
                icon={IInputText.ICO_COG} required={true} name={i18n.Input.way} id="way"
                isError={this.state.isModeError} error={i18n.Common.errors.invalidField} value={this.state.input.way}
                onChange={this.onChangeField.bind(this, this.state, 'way')}
                optionsValue={['0', '1']}
                optionsLabel={[i18n.Input.way_0, i18n.Input.way_1]}
              />
            </div>
            {/* Back To Normal */}
            {('' + this.state.input.mode === '0' || '' + this.state.input.mode === '1') &&
              <div>
                <Select
                  icon={IInputText.ICO_DNA} required={true} name={i18n.Input.backToNormal} id="backToNormal"
                  isError={this.state.isModeError} error={i18n.Common.errors.invalidField} value={this.state.input.backToNormal}
                  onChange={this.onChangeField.bind(this, this.state, 'backToNormal')}
                  optionsValue={['0', '1']}
                  optionsLabel={[i18n.Common.no, i18n.Common.yes]}
                />
              </div>
            }
            {/* Apparition Integration */}
            {('' + this.state.input.mode === '0' || '' + this.state.input.mode === '1') &&
              <div className="rowIntegration" >
                <div>
                  <InputText icon={IInputText.ICO_CLOCK} type="text" required={true}
                    name={i18n.Input.integrationValue} id="integrationValue" isError={this.state.isIntegrationUnitError}
                    error={i18n.Common.errors.invalidField} value={this.state.input.integrationValue}
                    onClick={this.onInputClick.bind(this, 'integrationValue', 0, 99, 1)} />
                </div>
                <div>
                  <Select
                    icon={IInputText.ICO_STOPWATCH} required={true} name={i18n.Common.unit} id="integrationUnit"
                    isError={this.state.isModeError} error={i18n.Common.errors.invalidField} value={this.state.input.integrationUnit}
                    onChange={this.onChangeField.bind(this, this.state, 'integrationUnit')}
                    optionsValue={['H', 'M', 'S']}
                    optionsLabel={[i18n.Common.units.hour, i18n.Common.units.minute, i18n.Common.units.second]}
                  />
                </div>
              </div>
            }
            {/* Disapparition Integration */}
            {('' + this.state.input.mode === '0' || '' + this.state.input.mode === '1') &&
              <div className="rowIntegration" >
                <div>
                  <InputText icon={IInputText.ICO_CLOCK} type="text" required={true}
                    name={i18n.Input.disparitionValue} id="disparitionValue" isError={this.state.isIntegrationUnitError}
                    error={i18n.Common.errors.invalidField} value={this.state.input.disparitionValue}
                    onClick={this.onInputClick.bind(this, 'disparitionValue', 0, 99, 1)} />
                </div>
                <div>
                  <Select
                    icon={IInputText.ICO_STOPWATCH} required={true} name={i18n.Common.unit} id="disparitionUnit"
                    isError={this.state.isModeError} error={i18n.Common.errors.invalidField} value={this.state.input.disparitionUnit}
                    onChange={this.onChangeField.bind(this, this.state, 'disparitionUnit')}
                    optionsValue={['H', 'M', 'S']}
                    optionsLabel={[i18n.Common.units.hour, i18n.Common.units.minute, i18n.Common.units.second]}
                  />
                </div>
              </div>
            }
            {/* Counter Total and Max  */}
            {'' + this.state.input.mode === '2' &&
              <div>
                <InputText icon={IInputText.ICO_SORT_NUMERIC_UP} type="text" required={true}
                  name={i18n.Input.counterMax} id="counterMax" isError={this.state.isCounterMaxError}
                  error={i18n.Common.errors.invalidField} value={this.state.input.counterMax}
                  onClick={this.onInputClick.bind(this, 'counterMax', 1, 99, 1)} />
              </div>
            }
            {/* Counter Total and Max  */}
            {'' + this.state.input.mode === '2' &&
              <div className="rowIntegration" >
                <div>
                  <InputText icon={IInputText.ICO_SORT_NUMERIC_UP} type="text" required={true}
                    name={i18n.Input.counterWeight} id="counterWeight" isError={this.state.isCounterWeightError}
                    error={i18n.Common.errors.invalidField} value={this.state.input.counterWeight}
                    onClick={this.onInputClick.bind(this, 'counterWeight', 1, 99, 1)} />
                </div>
                <div>
                  <Select
                    icon={IInputText.ICO_STOPWATCH} required={true} name={i18n.Common.unit} id="counterUnit"
                    isError={false} error={i18n.Common.errors.invalidField} value={this.state.input.counterUnit}
                    onChange={this.onChangeField.bind(this, this.state, 'counterUnit')}
                    optionsValue={['L', 'M', 'W', 'KW']}
                    optionsLabel={[i18n.Common.units.liter, i18n.Common.units.meter, i18n.Common.units.watt, i18n.Common.units.kilowatt]}
                  />
                </div>
              </div>
            }

            <div className="alertTitle">
              {i18n.Common.alert}
            </div>
            <div className="rowAlert">
              <div><CheckBox
                checked={this.state.input.mailAlert === 1} label={i18n.Media.mail} onClick={this.onMailClick.bind(this, this.state)} />
              </div>
              <div><CheckBox
                checked={this.state.input.smsAlert === 1} label={i18n.Media.sms} onClick={this.onSmsClick.bind(this, this.state)} />
              </div><div><CheckBox
                checked={this.state.input.pushAlert === 1} label={i18n.Media.push} onClick={this.onPushClick.bind(this, this.state)} />
              </div>
            </div>
          </div>
        </div>

      </div >

    );
  }
}

export default Input;


// WEBPACK FOOTER //
// ./src/pages/Input.tsx